import { ReactComponent as BaseSVG } from '../assets/Elområden-Sverige.svg';
import { ReactComponent as SE1SVG } from '../assets/Elområden-Sverige-SE1.svg';
import { ReactComponent as SE2SVG } from '../assets/Elområden-Sverige-SE2.svg';
import { ReactComponent as SE3SVG } from '../assets/Elområden-Sverige-SE3.svg';
import { ReactComponent as SE4SVG } from '../assets/Elområden-Sverige-SE4.svg';

const SwedenMap = ({ onRegionSelect, selectedRegion }) => {
    return (
        <div className="relative w-full max-w-[400px] mx-auto h-[600px] hidden md:flex md:items-center md:justify-center">
            <BaseSVG className="absolute top-0 left-0 w-full h-full" preserveAspectRatio="xMidYMid meet" />
            <SE1SVG 
                className={`absolute top-0 left-0 w-full h-full region pointer-events-none ${selectedRegion === 'SE1' ? 'active-se1' : ''}`}
                onClick={() => onRegionSelect('SE1')} 
                preserveAspectRatio="xMidYMid meet" 
            />
            <SE2SVG 
                className={`absolute top-0 left-0 w-full h-full region pointer-events-none ${selectedRegion === 'SE2' ? 'active-se2' : ''}`}
                onClick={() => onRegionSelect('SE2')} 
                preserveAspectRatio="xMidYMid meet" 
            />
            <SE3SVG 
                className={`absolute top-0 left-0 w-full h-full region pointer-events-none ${selectedRegion === 'SE3' ? 'active-se3' : ''}`}
                onClick={() => onRegionSelect('SE3')} 
                preserveAspectRatio="xMidYMid meet" 
            />
            <SE4SVG 
                className={`absolute top-0 left-0 w-full h-full region pointer-events-none ${selectedRegion === 'SE4' ? 'active-se4' : ''}`}
                onClick={() => onRegionSelect('SE4')} 
                preserveAspectRatio="xMidYMid meet" 
            />
        </div>
    );
};

export default SwedenMap;